var _defs, _circle, _path, _line, _line2, _line3, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEarth3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.25px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "earth-3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 12,
    cy: 12,
    r: 11.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.289,22.921C7.767,20.689,6.75,16.633,6.75,12S7.767,3.311,9.289,1.079"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 0.75,
    y1: 12,
    x2: 23.25,
    y2: 12
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 2.482,
    y1: 18,
    x2: 21.518,
    y2: 18
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 2.482,
    y1: 6,
    x2: 21.518,
    y2: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.711,1.079C16.233,3.311,17.25,7.367,17.25,12s-1.017,8.689-2.539,10.921"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarth3);
export default __webpack_public_path__ + "static/media/earth-3.fc2dfa4f853fafc3713caf67e36c0bda.svg";
export { ForwardRef as ReactComponent };